import React from "react"
import badge from "badges/humanity-hero.svg"
import { BadgeImage } from "backpack/badges/styled"

const HumanityHero = props => <BadgeImage src={badge} {...props} />

export default HumanityHero
